export default __webpack_public_path__ + "static/media/logo-redux.45e6cfea.png";